<video-playback-overlay-dialog [headerText]="'Media_Videos_ReplaceVideo' | translate">
	<div slot="headerActions">
		<button type="button" (click)="onCancel()" [hidden]="replaceVideoStage >= ReplaceVideoStage.UPLOAD_PROGRESS" vbUiBtnSecondaryNgx>
			{{ 'Cancel' | translate }}
		</button>

		<button type="button" (click)="onOk()" [disabled]="isUploadError" [hidden]="replaceVideoStage <= ReplaceVideoStage.CONFIRMATION" vbUiBtnPrimaryNgx>
			{{ 'Ok' | translate }}
		</button>
	</div>

	<div slot="content">

		<vb-loading-spinner *ngIf="!account; else content" [size]="'medium'">
		</vb-loading-spinner>

		<ng-template #content>
			<form class="text-align-center" name="form" [hidden]="replaceVideoStage !== ReplaceVideoStage.SELECT_FILE" fileUpload method="post" enctype="multipart/form-data" [singleFileUploads]="true" [maxChunkSize]="account.chunkUploadSizeBytes" (onAdd)="onFileAdd($event.file)" (submit)="noop">
				<p>{{ 'Media_Videos_Replace_Message' | translate }}</p>

				<div [ngClass]="styles.uploadBtnWrapper">
					<button type="button" [ngClass]="styles.uploadBtn" vbUiBtnPrimaryNgx>
						<span class="glyphicons plus"></span>
						{{ 'Media_Videos_Replace_SelectFile' | translate }}
					</button>
					<input type="file" name="videoFile" [ngClass]="styles.uploadBtnFileInput">
				</div>

				<div *ngIf="fileInputErrors" [ngClass]="styles.fileInputErrors" role="alert" vbUiErrorMessage>
					<div *ngIf="fileInputErrors.fileSize">{{ 'UploadExceededMaxFileSize' | translate }}</div>
					<div *ngIf="fileInputErrors.fileType">{{ 'UploadInvalidFileType' | translate }}</div>
				</div>
			</form>


			<div [ngSwitch]="replaceVideoStage">
				<div [ngClass]="styles.confirmation" *ngSwitchCase="ReplaceVideoStage.CONFIRMATION">
					<p>{{ 'Media_Videos_Replace_Confirmation' | translate }}</p>

					<div *ngIf="!isUploadError" class="text-align-center">
						<button type="button" [ngClass]="styles.confirmBtn" (click)="onConfirm()" vbUiBtnPrimaryNgx>
							{{ 'Media_Videos_Replace_Continue' | translate }}
						</button>
					</div>

					<div *ngIf="isUploadError">
						<div *ngIf="uploadErrors" class="margin-bottom-10" role="alert" vbUiErrorMessage>
							<div *ngIf="uploadErrors.processingFailed">{{ 'Media_Videos_Replace_ProcessingFailedMessage' | translate }}</div>
							<div *ngIf="uploadErrors.uploadFailed">{{ 'Media_Videos_Replace_UploadFailedMessage' | translate }}</div>
						</div>
						<button type="button" (click)="onRetry()" vbUiBtnPrimaryNgx>
							{{ 'Retry' | translate }}
						</button>
					</div>
				</div>

				<vb-ui-progress-bar *ngSwitchCase="ReplaceVideoStage.UPLOAD_PROGRESS" [ngClass]="styles.uploadProgress" [label]="'Media_Videos_Settings_Uploading' | translate" [progress]="uploadProgress">
				</vb-ui-progress-bar>

				<div *ngSwitchCase="ReplaceVideoStage.PROCESSING" class="text-align-center">
					<div layout="row" flex-align="center" flex-justify="center" [ngClass]="styles.processingSpinnerRow">
						<vb-loading-spinner [block]="false" [size]="'medium'" [ngClass]="styles.processingSpinner">
						</vb-loading-spinner>
						<div [ngClass]="styles.processingSpinnerMsg">
							{{ 'Media_Videos_Replace_ProcessingMessage' | translate }}
						</div>
					</div>
					<p>{{ 'Media_Videos_Replace_ProcessingMessageDetail' | translate }}</p>
				</div>

				<div *ngSwitchCase="ReplaceVideoStage.COMPLETE" class="text-align-center" [ngClass]="styles.completeMsg">
					{{ (isRevert ? 'Media_Videos_Replace_RestoredMessage' : 'Media_Videos_Replace_CompleteMessage') | translate }}
				</div>
			</div>

			<button type="button" [ngClass]="styles.restoreBtn" (click)="onRevert()" [hidden]="!canRevert" vbUiBtnPrimaryNgx>
				{{ 'Media_Videos_Replace_RevertMessage' | translate }}
			</button>
		</ng-template>
	</div>
</video-playback-overlay-dialog>
